<div class="containerTable" id="content" #content>
  <div class="row">
    <div class="col-md-8 text-right shipName">STENA SUEDE (9579042)</div>
    <div class="col-md-4 text-right date">02-01-2024</div>
  </div>
  <div class="first-table-container">
    <div class="text-center heading">HEATING PLAN No: 1</div>
    <div class="hDate">LOADING PORT(S): <span class="shipNames">ANTWERP + ROTTERDAM</span></div>
    <div class="hDate">DISCHARGE PORT(S): <span class="shipNames"> SINGAPORE (TBC)</span></div>
  </div>
  <div class="table-container scroll-bar">
    <table class="mat-elevation-z8" id="style-4">
      <thead>
        <tr>
          <th rowspan="2">Date</th>
          <th *ngFor="let header of headers" colspan="2">{{ header }}</th>
          <th rowspan="2">VG CARGO TEMP</th>
          <th colspan="3">Weather</th>
          <th colspan="4">Bunker Consp</th>
          <th colspan="1">HR</th>
        </tr>
        <tr>
          <ng-container *ngFor="let subheader of subheaders">
            <th>
              <span>{{ subheader }}</span>
            </th>
            <th><span>Heating</span></th>
          </ng-container>
          <th><span> Air Temp (°C)</span></th>
          <th><span> Sea Temp °C</span></th>
          <th><span>Wind Speed (KTS)</span></th>
          <th><span>Heating Boiler CONSP. (MT)</span></th>
          <th><span> Circulation Bunker CONSP. (MT)</span></th>
          <th><span> TOTAL Bunker CONSP. (MT)</span></th>
          <th><span>Boiler Load (%)</span></th>
          <th><span>No. OF Heating Hours</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of tableData">
          <td>{{ data.date }}</td>
          <ng-container *ngFor="let bunker of data.bunkerData">
            <td>{{ bunker.value }}</td>
            <td [style.color]="bunker.heating === 'ON' ? 'orangered' : 'default_color'">{{ bunker.heating }}</td>
          </ng-container>
          <td>{{ data.vgCargoTemp }}</td>
          <td>{{ data.weather.airTemp }}</td>
          <td>{{ data.weather.seaTemp }}</td>
          <td>{{ data.weather.windSpeed }}</td>
          <td>{{ data.bunkerConsp.heatingBoiler }}</td>
          <td>{{ data.bunkerConsp.circulationBunker }}</td>
          <td>{{ data.bunkerConsp.totalBunker }}</td>
          <td>{{ data.bunkerConsp.boilerLoad }}</td>
          <td>{{ data.heatingHours }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <footer class="footer">
    <div class="d-flex">
      <div class="site-logo">
        <img src="../../../assets/images/logo.png" class="logo" />
      </div>
      <!-- <span class="footerText"
        >Powered By Meraki Shipping Services- "Values With Expertise" // T: +91
        865 222 5187 // E: cargoheating@merakishippingservices.com</span
      > -->
    </div>
  </footer>
</div>

